import React from 'react';
import { Spin } from '@1c/ui';
import styles from './styles.module.scss';

const PageSpin: React.FC = () => {
  return <Spin size={60} className={styles['spin']} />;
};

export default PageSpin;
